import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import style from 'app/modules/mediaLibrary/components/mediaLibraryModal/footer/Footer.module.scss';
import { Button } from '@kontentino/ui';
import Modal from 'components/shared/Modal';

type Props = {
  onSelectSubmit: () => void;
  onCancel: () => void;
  selectedCount: number;
};

const Footer: FC<Props> = (props) => {
  const { t } = useTranslation();
  return (
    <Modal.Footer>
      <div className={style.dragImagesLabel}>{t('mediaLibrary.dragLabel')}</div>
      <Button
        onClick={props.onCancel}
        variant="secondary"
        data-cy="media-library_cancel-button"
      >
        {t('cancel')}
      </Button>
      <Button
        onClick={props.onSelectSubmit}
        disabled={props.selectedCount === 0}
        data-cy="media-library_select-button"
      >
        {props.selectedCount > 1
          ? t('mediaLibrary.selectWithCount', { count: props.selectedCount })
          : t('select')}
      </Button>
    </Modal.Footer>
  );
};

export default Footer;
